var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"var(--primary)","display":"flex","flex-direction":"column","align-items":"center"}},[_c('Titles',{attrs:{"type":1,"text":'Infraestrutura'}}),_c('CardsBox',{staticStyle:{"max-width":"1600px"},attrs:{"infraArray":_vm.infra}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }